import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Button } from 'react-bootstrap';
import InnerHtmlContent from '../InnerHtmlContent';

const OptionButton = ({ active, onClick, option, prefix, namespace, disabled, t }) => (
  <Button
    className="booking-option-btn"
    active={active}
    onClick={() => onClick(option.id)}
    block
    bsStyle="default"
    bsSize="large"
    disabled={disabled}
  >
    <span className="booking-option-btn-title"><InnerHtmlContent content={t(`${prefix}.${option.id}.title`)} /></span>
    <span className="booking-option-btn-info"><InnerHtmlContent content={t(`${prefix}.${option.id}.subTitle`, { defaultValue: '' })} /></span>
  </Button>
);

OptionButton.propTypes = {
  t: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
  prefix: PropTypes.string.isRequired,
  namespace: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

OptionButton.defaultProps = {
  disabled: false
};

export default translate(props => props.namespace, { wait: true })(OptionButton);



// WEBPACK FOOTER //
// ./src/components/OptionButton/OptionButton.jsx